var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !!_vm.currentOffer && _vm.isActiveByStock
    ? _c("div", { staticClass: "shopoffer-widget widget-danger" }, [
        _c("div", { staticClass: "inner" }, [
          _vm.durationInDays > 1
            ? _c("div", { staticClass: "offer-head" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Ecomsilio::Template.liveShoppingOfferName"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ecomsilio::Template.liveShoppingUntil", {
                        days: _vm.durationInDays,
                      })
                    )
                  ),
                ]),
              ])
            : _c("div", { staticClass: "offer-head" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Ecomsilio::Template.liveShoppingOfferName"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Ecomsilio::Template.liveShoppingUntilToday"
                      )
                    )
                  ),
                ]),
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "offer-body" }, [
            _c(
              "a",
              {
                staticClass: "img-link",
                attrs: {
                  href: _vm.item.texts.urlPath + "_" + _vm.item.item.id,
                },
              },
              [
                !isNaN(_vm.itemPriceRebatePercentage) &&
                _vm.itemPriceRebatePercentage > 0
                  ? _c("div", { staticClass: "prices-rebate" }, [
                      _vm._v("-" + _vm._s(_vm.itemPriceRebatePercentage) + "%"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("lazy-img", {
                  attrs: {
                    "picture-class": "img-fluid d-block",
                    "image-url": _vm.item.images.all[0].urlMiddle,
                    alt: _vm.item.texts.name1,
                    title: _vm.item.texts.name1,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "shopoffer-details" }, [
              _c(
                "a",
                {
                  staticClass: "thumb-title",
                  attrs: {
                    href: _vm.item.texts.urlPath + "_" + _vm.item.item.id,
                  },
                },
                [_vm._v(_vm._s(_vm._f("itemName")(_vm.item)))]
              ),
              _vm._v(" "),
              _vm.item.texts.shortDescription != ""
                ? _c("div", { staticClass: "offer-description" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.item.texts.shortDescription) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "prices-container" },
                [
                  _c(
                    "div",
                    { staticClass: "live-shopping-price" },
                    [
                      !!_vm.item.item && _vm.item.item.salableVariationCount > 1
                        ? [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.itemFromPrice",
                                    {
                                      price:
                                        _vm.prices.price.unitPrice.formatted,
                                    }
                                  )
                                ),
                              },
                            }),
                            _c("sup", [_vm._v("*")]),
                          ]
                        : [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.prices.price.unitPrice.formatted)
                            ),
                            _c("sup", [_vm._v("*")]),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.prices.rrp && _vm.prices.rrp.unitPrice.value > 0
                    ? [
                        _vm.prices.isRrpDefaultPrice
                          ? _c("span", {
                              staticClass: "shopoffer-old-price",
                              domProps: {
                                innerHTML: _vm._s(_vm.oldPriceBefore),
                              },
                            })
                          : _c("span", {
                              staticClass: "shopoffer-old-price",
                              domProps: { innerHTML: _vm._s(_vm.oldPriceRrp) },
                            }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "live-shopping-prices-additional-info" },
                [
                  !(
                    _vm.item.unit.unitOfMeasurement === "C62" &&
                    _vm.item.unit.content === 1
                  )
                    ? _c("div", { staticClass: "live-shopping-unit-price" }, [
                        _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.item.unit.names.name))]),
                        _vm._v(" "),
                        _vm.item.variation.mayShowUnitPrice
                          ? _c("span", [
                              _vm._v("| " + _vm._s(_vm.prices.price.basePrice)),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "offer-cta" }, [
                _c("div", { staticClass: "offer-countdown" }, [
                  _c("hr", {
                    staticClass: "live-shopping-countdown-separator",
                  }),
                  _vm._v(" "),
                  !!_vm.duration
                    ? _c(
                        "div",
                        { staticClass: "live-shopping-countdown-heading" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.liveShoppingOfferEndsIn"
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.duration
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "live-shopping-countdown-thread-container",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "live-shopping-countdown-thread" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "live-shopping-countdown-thread-number offer-hours",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.duration.hours) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "small" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.liveShoppingHours"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "live-shopping-countdown-thread" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "live-shopping-countdown-thread-number offer-minutes",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.duration.minutes) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "small" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.liveShoppingMinutes"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "live-shopping-countdown-thread" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "live-shopping-countdown-thread-number offer-seconds",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.duration.seconds) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "small" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.liveShoppingSeconds"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "offer-button btn btn-primary btn-appearance",
                    attrs: {
                      href: _vm.item.texts.urlPath + "_" + _vm.item.item.id,
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "Ecomsilio::Template.liveShoppingButtonText"
                        )
                      ) + " "
                    ),
                    _c("i", {
                      staticClass: "fa fa-arrow-right",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _c("div", [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }